import { ThemeIcon } from "@mantine/core";

export const themeIconComponentSettings = ThemeIcon.extend({
  defaultProps: {
    color: "gray",
    variant: "transparent",
    size: "sm",
  },
});
